// Extensie is verplicht: package.json staat op "type": "module", dus .js-bestanden
// worden als strikte ESM behandeld.
import { collection, doc } from 'firebase/firestore';
import { db } from '../firebase.js';

/**
 * Spelers staan onder het seizoen, niet in één gedeelde collectie.
 *
 * Reden: het document-id is het Sportmonks-speler-id. In één collectie bestond er
 * dus maar één rij per speler, en overschreef een nieuwe seizoensimport de
 * gegevens van iedereen die ook vorig seizoen meedeed.
 *
 * Het document-id blijft het kale speler-id, zodat `doc.id` en het veld `id`
 * gelijk blijven en verwijzingen vanuit een veiling (auctionPlayers, draft-
 * offerings, auctionTransfers) blijven kloppen.
 */

/** @param {string|number} seasonId */
export function seasonPlayersCollection(seasonId) {
    return collection(db, 'seasons', String(seasonId), 'players');
}

/**
 * @param {string|number} seasonId
 * @param {string|number} playerId
 */
export function seasonPlayerDoc(seasonId, playerId) {
    return doc(db, 'seasons', String(seasonId), 'players', String(playerId));
}

/**
 * Clubtransfers van één seizoen. Het document-id is het Sportmonks-transfer-id.
 *
 * @param {string|number} seasonId
 */
export function seasonPlayerTransfersCollection(seasonId) {
    return collection(db, 'seasons', String(seasonId), 'playerTransfers');
}

/**
 * De deelnemende clubs van één seizoen. Stond eerder in de root als `teams` met
 * een `seasons`-array; die relatie is omgedraaid. De naam is `clubs` omdat `teams`
 * in dit model al de opstelling van een deelnemer is.
 *
 * @param {string|number} seasonId
 */
export function seasonClubsCollection(seasonId) {
    return collection(db, 'seasons', String(seasonId), 'clubs');
}

/**
 * @param {string|number} seasonId
 * @param {string|number} clubId
 */
export function seasonClubDoc(seasonId, clubId) {
    return doc(db, 'seasons', String(seasonId), 'clubs', String(clubId));
}
